<template>
  <!-- Top dogadjaji (pocetna): dogadjaji oznaceni kao top, sa slikom, padajuca lista kategorija -->
  <EventsBlock
    :items="items"
    :filter="{ top_event: true }"
    :limit="8"
    :year="year"
    :month="month"
    title="TOP DOGAĐAJI"
    dropdown="category"
  />
</template>

<script setup>
import EventsBlock from '~/components/widgets/Event/EventsBlock.vue'

defineProps({
  items: { type: Array, default: () => [] },
  year: Number,
  month: String
})
</script>
